import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const automationTools = [
  {
    icon: 'ri-box-3-line',
    name: 'Packer',
    desc: 'VM görüntü oluşturma sürecini otomatikleştirir. Packer entegrasyonu ile Linux ve Windows ortamları için makine kontrollü görüntüler oluşturun, yazılım yükleyin, görüntüleri etiketleyin ve tutarlı bir temel imaj boyunca sürdürün.',
  },
  {
    icon: 'ri-map-2-line',
    name: 'Terraform',
    desc: 'Tek bir modelden altyapıyı ve uygulamaları tanımlayın. Milyonlarca boyuta yeniden ölçeklendirin ya da tek seferlik test kümesi ve paralel geliştirme ortamları için küçülün. Terraform, aynı tutarlı planı kullanır.',
  },
  {
    icon: 'ri-terminal-box-line',
    name: 'Ansible',
    desc: "Uygulama stajları, bağımlılıklar ve araçları dağıtın. OS yapılandırmalarını uygulayın. Terraform'ın yeni oluşturulduğu hedef gruplara dağıtın. Ansible tutarlı konfigürasyon yönetimi sağlar.",
  },
];

const automationSteps = [
  { step: '1', title: 'Packer temel görüntüyü oluşturur', desc: 'Standart, güvenilir bir VM görüntüsü oluşturun' },
  { step: '2', title: 'Terraform altyapıyı sağlar', desc: 'VM görüntüsünü kullanarak altyapıyı ve uygulamaları tanımlayın' },
  { step: '3', title: 'Ansible yapılandırır', desc: 'Uygulama stajlarını, bağımlılıkları ve araçları dağıtın' },
  { step: '4', title: 'VergeOS otomatikleştirir', desc: 'Her adım önceki adımın çıktısını besler — tamamen otomatik teslimat' },
];

const whyVergeOS = [
  { icon: 'ri-layers-line', title: 'Bağımlılıkları Azaltır', desc: 'Dağıtık depolama dizileri yerine tek bir altyapı işletim sistemine bağımlı.' },
  { icon: 'ri-file-copy-line', title: "Packer Image'larını Temel Alır", desc: 'Hiper yönetici özelinde olmayan, taşınabilir image oluşturma.' },
  { icon: 'ri-git-branch-line', title: 'Terraform Durumunu Yönetir', desc: 'Tek bir işletim sistemi, birden fazla katman değil.' },
  { icon: 'ri-settings-4-line', title: 'Öngörülebilir Dağıtım ve Geri Alma', desc: 'Her dağıtım aynı sonucu verir; geri alma bir plan kadar kolaydır.' },
];

const faqList = [
  {
    q: 'Üç aracı (Packer, Terraform ve Ansible) birlikte kullanmak zorunda mıyım?',
    a: "Hayır. Her araç bağımsız olarak değer sağlar. Packer'ı standart görüntüler oluşturmak için kullanabilirsiniz, Terraform'ı altyapıyı sağlamak için, Ansible'ı yapılandırma yönetimi için. Birlikte kullandığınızda etkileri çarpılır.",
  },
  {
    q: 'VergeOS mevcut Terraform şablonlarımla nasıl çalışır?',
    a: 'VergeOS için bir Terraform sağlayıcısı mevcuttur. Bu sağlayıcı, mevcut şablonlarınızı VergeOS ortamınızda kullanmanıza ve altyapınızı kod olarak yönetmenize olanak tanır.',
  },
  {
    q: 'Ansible, VergeOS yönetimi için kullanılabilir mi?',
    a: 'Evet. Ansible ile VergeOS ortamlarında uygulama stajlarını dağıtabilir, OS yapılandırmalarını uygulayabilir ve sürekli konfigürasyon yönetimi oluşturabilirsiniz.',
  },
  {
    q: 'Bu otomasyon çoklu site veya çoklu bölge dağıtımlarını destekler mi?',
    a: "Evet. VergeOS'un iç içe çok kiracılılık modeli, Packer/Terraform/Ansible'ın birden fazla siteye veya VDC'ye tutarlı şekilde dağıtım yapmasına olanak tanır; her site kendi izole ortamında çalışır.",
  },
  {
    q: 'Mevcut VM altyapısından geçiş yaparak otomatik altyapıya geçiş nasıl gerçekleşir?',
    a: "Otomasyon platformu bir temel görüntüden başlar. Bu, destekli Packer entegrasyonu, Terraform ve Ansible'ın tutarlı, tekrarlanabilir iş akışları aracılığıyla eski ortamınızı ortadan kaldırmanıza olanak tanır.",
  },
];

const infraAutoFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Üç aracı (Packer, Terraform ve Ansible) birlikte kullanmak zorunda mıyım?', acceptedAnswer: { '@type': 'Answer', text: "Hayır. Her araç bağımsız olarak değer sağlar. Packer'ı standart görüntüler oluşturmak, Terraform'ı altyapıyı sağlamak, Ansible'ı yapılandırma yönetimi için kullanabilirsiniz." } },
    { '@type': 'Question', name: 'VergeOS mevcut Terraform şablonlarımla nasıl çalışır?', acceptedAnswer: { '@type': 'Answer', text: 'VergeOS için bir Terraform sağlayıcısı mevcuttur. Bu sağlayıcı, mevcut şablonlarınızı VergeOS ortamınızda kullanmanıza ve altyapınızı kod olarak yönetmenize olanak tanır.' } },
    { '@type': 'Question', name: 'Ansible, VergeOS yönetimi için kullanılabilir mi?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. Ansible ile VergeOS ortamlarında uygulama stajlarını dağıtabilir, OS yapılandırmalarını uygulayabilir ve sürekli konfigürasyon yönetimi oluşturabilirsiniz.' } },
    { '@type': 'Question', name: 'Bu otomasyon çoklu site dağıtımlarını destekler mi?', acceptedAnswer: { '@type': 'Answer', text: "Evet. VergeOS'un iç içe çok kiracılılık modeli, Packer/Terraform/Ansible'ın birden fazla siteye tutarlı şekilde dağıtım yapmasına olanak tanır." } },
  ],
};

const infraAutoAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS Altyapı Otomasyonu',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS için Packer, Terraform ve Ansible entegrasyonu. Uçtan uca altyapı otomasyonu ile öngörülebilir, tutarlı dağıtımlar.',
  url: `${SITE_URL}/infrastructure-automation`,
};

export default function InfrastructureAutomationPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="Altyapı Otomasyonu | Packer Terraform Ansible ile VergeOS"
        description="VergeOS ile Packer, Terraform ve Ansible entegrasyonu. Uçtan uca altyapı otomasyonu, öngörülebilir dağıtımlar ve sıfır manuel müdahale ile infrastructure as code."
        keywords="altyapı otomasyonu, Terraform, Packer, Ansible, VergeOS, infrastructure as code, IaC, DevOps"
        canonicalPath="/infrastructure-automation"
        jsonLd={[infraAutoAppJsonLd, infraAutoFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Mimari
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">Otomatik</span> Altyapı
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">VergeOS için Packer, Terraform ve Ansible Entegrasyonu</p>
            <p className="text-gray-400 text-sm max-w-2xl mx-auto mb-8">
              Otomasyonu Gerçeğe Dönüştüren Entegre Bir Altyapı İşletim Sistemi
            </p>
          </div>
        </section>

        {/* Intro */}
        <section className="py-14 bg-gray-50 border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-lg font-semibold text-[#1e293b] mb-3">
              Öngörülebilir, tutarlı otomasyonlu, tekrarlanabilir dağıtımlar oluşturun.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Modern BT ekipleri öngörülebilir dağıtımlar, tutarlı ortamlar ve otomasyonu kıran manuel müdahale olmadan yeniden dağıtım kapasitesi ister. VergeOS artık Packer, Terraform ve Ansible&apos;ı destekler; bu sayede altyapı yaşam döngüsünü baştan sona otomatikleştirebilirsiniz.
            </p>
          </div>
        </section>

        {/* Three Tools */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">VergeOS, Packer, Terraform ve Ansible&apos;ı Destekler</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">
                Her araç ayrı ayrı değer sağlar; birlikte kullanıldığında altyapı yaşam döngüsünü uçtan uca otomatikleştirir.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {automationTools.map((tool) => (
                <div key={tool.name} className="bg-[#f8fafc] rounded-lg border border-gray-100 p-6">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#0f1117] rounded-lg text-[#e8600a] mb-4">
                    <i className={`${tool.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-bold text-[#1e293b] mb-3">{tool.name}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{tool.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pipeline Flow */}
        <section className="py-20 bg-[#0f1117]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-white mb-4">Uçtan Uca Otomasyon Zinciri</h2>
              <p className="text-gray-400 max-w-2xl mx-auto text-sm">
                Packer, Terraform ve Ansible birbirleriyle bütünleşik olarak çalışır. Her araç önceki aracın çıktısını besler — tutarlı, tam otomatik teslimat sağlar.
              </p>
            </div>
            <div className="grid md:grid-cols-4 gap-4">
              {automationSteps.map((s, i) => (
                <div key={s.step} className="relative">
                  <div className="bg-white/5 rounded-lg border border-white/10 p-6">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#e8600a] rounded-full text-white font-bold text-sm mb-4">
                      {s.step}
                    </div>
                    <h3 className="font-semibold text-white mb-2 text-sm">{s.title}</h3>
                    <p className="text-xs text-gray-400">{s.desc}</p>
                  </div>
                  {i < automationSteps.length - 1 && (
                    <div className="hidden md:flex absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-5 h-5 items-center justify-center text-[#e8600a]">
                      <i className="ri-arrow-right-line text-lg"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Packer Detail */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                  IMAGE Pipeline
                </div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Otomasyon, Image Pipeline ile Başlar</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Bir altyapı platformu, öngörülemeyen dağıtımlar yapıyorsa tutarlılık mümkün değildir. VergeOS, Packer ile temel image&apos;ları destekler; her VM&apos;ın bakımını üstlenir.
                </p>
                <ul className="space-y-3">
                  {[
                    'Linux ve Windows için makine kontrollü görüntüler oluşturun',
                    'Yazılım yükleyin ve görüntüleri etiketleyin',
                    'GIt aracılığıyla temel bir görüntü boyunca tutarlı bir görüntü sürdürün',
                    'Test aşamalarını aynı görüntü üzerinde çalıştırarak bir sonraki aşamaya geçin',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-checkbox-circle-line text-[#e8600a] text-lg shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/35be8ad0b8b7b70babc227d0b7a76adc.jpg"
                  alt="Packer Görüntü Pipeline"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Terraform Detail */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Terraform%20infrastructure%20as%20code%20deployment%20visualization%20showing%20infrastructure%20blueprint%20with%20virtual%20machines%20networks%20storage%20defined%20in%20code%20deployed%20across%20multiple%20environments%20dark%20background%20orange%20highlights%20technical%20IaC%20architecture%20diagram&width=580&height=400&seq=infra_terraform1&orientation=landscape"
                  alt="Terraform Altyapı Tanımı"
                  className="w-full h-full object-top"
                />
              </div>
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                  Terraform Entegrasyonu
                </div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Altyapıyı Güvenle Tanımlayın ve Dağıtın</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Görüntüler temeli oluşturan altyapıyı destekler. VergeOS ile Terraform entegrasyonu sayesinde ekibiniz şunları yapabilir:
                </p>
                <ul className="space-y-3">
                  {[
                    "VM'leri, ağları, depolama alanını ve VM spesifikasyonlarını tek bir modelden tanımlayın",
                    'Milyonlarca boyuta yeniden ölçeklendirin ya da tek seferlik ortamlar için küçülün',
                    'Tam test kümesi veya paralel geliştirme ortamları oluşturun',
                    'Ortamlar genelinde iş akışları ve modüller için öngörülebilir tanımlar sağlayın',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-checkbox-circle-line text-[#e8600a] text-lg shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Ansible Detail */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-block bg-[#e8600a]/10 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                  Ansible Entegrasyonu
                </div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Drift Olmadan Yapılandırma</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Son görüntü ve altyapı pipeline tutarlı yapılandırmayı destekler. Ansible&apos;ı Terraform ile birlikte kullanarak ekibiniz şunları yapabilir:
                </p>
                <ul className="space-y-3">
                  {[
                    'Uygulama stajları, bağımlılıklar ve araçları dağıtın',
                    'OS yapılandırmalarını uygulayın',
                    "Terraform'ın yeni oluşturulduğu hedef gruplara dağıtın",
                    'Hedef gruplar genelinde tutarlı yapılandırma ortamları ve geri alma durumu oluşturun',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-gray-700">
                      <i className="ri-checkbox-circle-line text-[#e8600a] text-lg shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Ansible%20configuration%20management%20visualization%20showing%20playbook%20deployment%20across%20multiple%20virtual%20machines%20ensuring%20consistent%20configuration%20state%2C%20dark%20background%20orange%20highlights%20automation%20workflow%20diagram%2C%20configuration%20drift%20prevention%20technical%20visualization&width=580&height=400&seq=infra_ansible1&orientation=landscape"
                  alt="Ansible Yapılandırma Yönetimi"
                  className="w-full h-full object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why VergeOS as substrate */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">Birleşik Altyapı OS, Pipeline&apos;ı Güçlendirir</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">
                Geleneksel sanallaştırma, dağıtılmış depolama dizileri, ayrı ağ katmanları ve birden fazla yönetim aracı gerektirir. VergeOS tüm bunları tek bir altyapı işletim sisteminde birleştirir.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {whyVergeOS.map((f) => (
                <div key={f.title} className="bg-white rounded-lg border border-gray-100 p-6 text-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mx-auto mb-4">
                    <i className={`${f.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{f.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Exit VMware CTA */}
        <section className="py-16 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">Mevcut Sanallaştırma Platformunuzdan Kolayca Otomatik Altyapıya Geçin</h2>
            <p className="text-gray-400 mb-8 text-sm leading-relaxed max-w-2xl mx-auto">
              Otomasyon platformu, destekli Packer entegrasyonu, Terraform ve Ansible ile eski ortamınızdan tutarlı, tekrarlanabilir iş akışları aracılığıyla geçiş yapmanıza olanak tanır.
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0">
                      <i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                    </span>
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
